<template>
  <div class="CompletionBlock">
    <div ref="textBlock">
      {{ displayCompletion }}
    </div>
    <svg
      :width="width"
      height="8"
      class="mt-5"
    >
      <Completion
        :x="x"
        :y="y"
        :r="r"
        :width="width"
        :height="height"
        :completion="completion"
      />
    </svg>
  </div>
</template>

<script>
  import Completion from '@/components/common/RelationCard/RelationCompletion'
  import { getCompletionLabel } from '@/utils/person.utils'

  export default {
    components: {
      Completion,
    },
    props: {
      completion: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        x: 0,
        y: 0,
        r: 5,
        width: 100,
        height: 8,
      }
    },
    computed: {
      displayCompletion() {
        return getCompletionLabel(
          this.$t.bind(this),
          this.$n.bind(this),
          'main.completion.profile',
          this.completion
        )
      },
    },
    mounted() {
      this.width = this.$refs.textBlock.offsetWidth
      // eslint-disable-next-line vue/no-mutating-props
      this.completion = this.completion || 0
    },
  }
</script>

<style scoped lang="scss">
.CompletionBlock {
  border-radius: 8px;
}
</style>
